// extracted by mini-css-extract-plugin
module.exports = {"banner":"scheduled-maintenance-banner_banner__22akD"};